module.exports = __webpack_public_path__ + "img/error1.3001b720.png";